export default "__VITE_ASSET__D2$F_3Io__"